<article
  id="canvasComponent"
  class="viewerAsset viewerAssetCanvas"
  [class.justify-content-around]="zoomLevel <= 100"
  [class.justify-content-between]="zoomLevel > 100"
  [class.w-100]="zoomLevel > 100">
  <div
    class="viewerCanvasWrapper"
    [ngClass]="getWrapperClasses()"
    [attr.aria-hidden]="shouldAnnounce() ? null : 'true'"
    [attr.role]="shouldAnnounce() ? 'img' : null"
    [attr.aria-label]="shouldAnnounce() ? (asset?.alternateText || '') : null"
    [tabindex]="shouldAnnounce() ? 0 : -1">
    @if (background) {
      <zbp-drawing
        id="canvasDocument"
        [tool]="selectedTool"
        [background]="background"
        [orientation]="getOrientation()"
        [color]="drawingColor"
        [brushSize]="brushSize"
      [zoomLevel]="zoomLevel"></zbp-drawing>
    }
  </div>
</article>
